export Fab from './Fab'

export default from './Fab'



// WEBPACK FOOTER //
// ./src/Fab/index.js